import ArticleLayout from '@/components/feature/ArticleLayout';
import articleContents from '@/mocks/article-content';

export default function ArticleStrategie() {
  return <ArticleLayout article={articleContents['strategie-ricerca-prodotti']} />;
}